/**
 * BILA FRONT FAQ Accordion Functionality
 */

// BILA Accordion Functionality
document.addEventListener("DOMContentLoaded", function () {
    // Initialize all accordions
    initBilaAccordions();

    // Function to initialize accordions
    function initBilaAccordions() {
        const accordions = document.querySelectorAll(".bila-accordion");

        accordions.forEach((accordion) => {
            const accordionId = accordion.id || accordion.dataset.accordionId;
            const activeFirst = accordion.dataset.activeFirst === "yes";
            const showIcons = accordion.dataset.icons !== "no";

            // Set up accordion items
            const items = accordion.querySelectorAll(".bila-accordion-item");

            // Auto-activate first item if specified
            if (activeFirst && items.length > 0) {
                const firstItem = items[0];
                if (!firstItem.classList.contains("active")) {
                    openAccordionItem(firstItem, true);
                }
            }

            // Add click handlers to triggers
            items.forEach((item) => {
                const trigger = item.querySelector(".bila-accordion-trigger");
                const content = item.querySelector(".bila-accordion-content");

                if (trigger && content) {
                    // Remove any existing event listeners
                    trigger.replaceWith(trigger.cloneNode(true));
                    const newTrigger = item.querySelector(
                        ".bila-accordion-trigger",
                    );

                    newTrigger.addEventListener("click", function (e) {
                        e.preventDefault();

                        const isActive = item.classList.contains("active");

                        // Close all other items in this accordion
                        if (!isActive) {
                            items.forEach((otherItem) => {
                                if (
                                    otherItem !== item &&
                                    otherItem.classList.contains("active")
                                ) {
                                    closeAccordionItem(otherItem);
                                }
                            });
                        }

                        // Toggle current item
                        if (isActive) {
                            closeAccordionItem(item);
                        } else {
                            openAccordionItem(item);
                        }
                    });

                    // Keyboard support
                    newTrigger.addEventListener("keydown", function (e) {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            this.click();
                        }

                        // Arrow key navigation
                        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                            e.preventDefault();
                            navigateAccordionItems(
                                item,
                                e.key === "ArrowDown" ? "next" : "prev",
                            );
                        }

                        // Home/End keys
                        if (e.key === "Home") {
                            e.preventDefault();
                            const firstItem = items[0];
                            if (firstItem) {
                                closeAllAccordionItems(items);
                                openAccordionItem(firstItem);
                                firstItem
                                    .querySelector(".bila-accordion-trigger")
                                    .focus();
                            }
                        }

                        if (e.key === "End") {
                            e.preventDefault();
                            const lastItem = items[items.length - 1];
                            if (lastItem) {
                                closeAllAccordionItems(items);
                                openAccordionItem(lastItem);
                                lastItem
                                    .querySelector(".bila-accordion-trigger")
                                    .focus();
                            }
                        }
                    });
                }
            });

            // Add accordion to global object for external control
            if (!window.bilaAccordions) window.bilaAccordions = {};
            window.bilaAccordions[accordionId] = {
                openAll: () => openAllAccordionItems(items),
                closeAll: () => closeAllAccordionItems(items),
                openItem: (index) => {
                    if (items[index]) {
                        openAccordionItem(items[index]);
                    }
                },
                closeItem: (index) => {
                    if (items[index]) {
                        closeAccordionItem(items[index]);
                    }
                },
            };
        });
    }

    // Helper functions
    function openAccordionItem(item, initial = false) {
        const trigger = item.querySelector(".bila-accordion-trigger");
        const content = item.querySelector(".bila-accordion-content");

        if (!trigger || !content) return;

        item.classList.add("active");
        trigger.setAttribute("aria-expanded", "true");
        content.removeAttribute("hidden");

        if (!initial) {
            content.style.maxHeight = content.scrollHeight + "px";

            // Dispatch custom event
            item.dispatchEvent(
                new CustomEvent("bila-accordion-open", {
                    bubbles: true,
                    detail: { item: item },
                }),
            );
        }
    }

    function closeAccordionItem(item) {
        const trigger = item.querySelector(".bila-accordion-trigger");
        const content = item.querySelector(".bila-accordion-content");

        if (!trigger || !content) return;

        item.classList.remove("active");
        trigger.setAttribute("aria-expanded", "false");
        content.style.maxHeight = "0";

        // Wait for transition, then hide
        setTimeout(() => {
            content.setAttribute("hidden", "");
        }, 500);

        // Dispatch custom event
        item.dispatchEvent(
            new CustomEvent("bila-accordion-close", {
                bubbles: true,
                detail: { item: item },
            }),
        );
    }

    function openAllAccordionItems(items) {
        items.forEach((item) => openAccordionItem(item));
    }

    function closeAllAccordionItems(items) {
        items.forEach((item) => closeAccordionItem(item));
    }

    function navigateAccordionItems(currentItem, direction) {
        const items = Array.from(
            currentItem.parentElement.querySelectorAll(".bila-accordion-item"),
        );
        const currentIndex = items.indexOf(currentItem);

        let targetIndex;
        if (direction === "next") {
            targetIndex =
                currentIndex < items.length - 1 ? currentIndex + 1 : 0;
        } else {
            targetIndex =
                currentIndex > 0 ? currentIndex - 1 : items.length - 1;
        }

        const targetItem = items[targetIndex];
        const targetTrigger = targetItem.querySelector(
            ".bila-accordion-trigger",
        );

        // Close current if open
        if (currentItem.classList.contains("active")) {
            closeAccordionItem(currentItem);
        }

        // Open target
        openAccordionItem(targetItem);

        // Focus target trigger
        if (targetTrigger) {
            targetTrigger.focus();
        }
    }

    // Public API
    window.BILAAccordion = {
        init: initBilaAccordions,
        openAll: function (accordionId) {
            if (window.bilaAccordions && window.bilaAccordions[accordionId]) {
                window.bilaAccordions[accordionId].openAll();
            }
        },
        closeAll: function (accordionId) {
            if (window.bilaAccordions && window.bilaAccordions[accordionId]) {
                window.bilaAccordions[accordionId].closeAll();
            }
        },
        openItem: function (accordionId, index) {
            if (window.bilaAccordions && window.bilaAccordions[accordionId]) {
                window.bilaAccordions[accordionId].openItem(index);
            }
        },
        closeItem: function (accordionId, index) {
            if (window.bilaAccordions && window.bilaAccordions[accordionId]) {
                window.bilaAccordions[accordionId].closeItem(index);
            }
        },
    };

    // Re-initialize accordions after AJAX content loads
    document.addEventListener("ajaxComplete", initBilaAccordions);
    document.addEventListener("DOMNodeInserted", function (e) {
        if (
            e.target.classList &&
            e.target.classList.contains("bila-accordion")
        ) {
            initBilaAccordions();
        }
    });
});
